export const locale = {
    cz: {
        moduleOptions: {
            previewPart: 'Náhled',
            settingsPart: 'Nastavení',
        },
        actionBar: {
            fail: 'Chyba při zpracování',
            waiting: 'Stahování souboru',
        },
        alertMsg: 'Pro lepší zobrazení v dokumentu použijte tlačítko pro export.',
        pageOption: 'Nastavení stránky',
        templateOption: 'Šablony',
        orientation: {
            portrait: 'Na výšku',
            landscape: 'Na šířku',
        },
        scaleRange: {
            range: 'Rozsah měřítka',
            delimiter: 'až',
        },
        size: {
            a4: 'A4',
            a3: 'A3',
        },
        map: {
            waiting: 'Mapa se načítá ...',
        },
        close: 'Zavřít',
        settingsItemSwitch: 'Skrýt/zobrazit',
        margins: 'Okraje',
        attribution: {
            overMap: 'Přes mapu',
            outsideOfMap: 'Mimo mapu',
        },
    },
    en: {
        moduleOptions: {
            previewPart: 'Preview',
            settingsPart: 'Settings',
        },
        actionBar: {
            fail: 'Processing error',
            waiting: 'Downloading file',
        },
        alertMsg: 'Please use the export button below for a better rendering on the document.',
        pageOption: 'Page setup',
        templateOption: 'Templates',
        orientation: {
            portrait: 'Portrait',
            landscape: 'Landscape',
        },
        scaleRange: {
            range: 'Scale range',
            delimiter: 'to',
        },
        size: {
            a4: 'A4',
            a3: 'A3',
        },
        map: {
            waiting: 'Map loading ...',
        },
        close: 'Close',
        settingsItemSwitch: 'Hide/show',
        margins: 'Margins',
        attribution: {
            overMap: 'Over map',
            outsideOfMap: 'Outside of map',
        },
    },
};
//# sourceMappingURL=locale.js.map